import { h } from 'preact';
import PropTypes from 'prop-types';

import SlimBannerBottomWPN from '../../containers/slim-banner-bottom-WPN/slim-banner-bottom-WPN';

export const SlimBannerComponent = ({ $root, htmlProps, htmlPushNotificationsProps, widget }) => (
  <SlimBannerBottomWPN
    htmlProps={htmlProps}
    selectBoxes={htmlPushNotificationsProps?.selectBoxes || []}
    widget={widget}
    $root={$root}
  />
);

SlimBannerComponent.propTypes = {
  htmlProps: PropTypes.object.isRequired,
  htmlPushNotificationsProps: PropTypes.object.isRequired,
  $root: PropTypes.object.isRequired,
  widget: PropTypes.object.isRequired,
};
